import { a } from './chunk-XCSSTYD2.mjs';
import { create } from 'zustand';

var d=create((o,p)=>({...a(o,p),isActive:!1,show({characterId:i,noteId:t}){i&&o({characterId:i,noteId:t,isActive:!0});}}));

export { d as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-MUA5L3IJ.mjs.map